export const getUserPoolWebClientId = () => `${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}`
export const getAWSRegion = () => `${process.env.REACT_APP_AWS_REGION}`
export const getUserPoolId = () => `${process.env.REACT_APP_USER_POOL_ID}`
